var Masonry = require("masonry-layout");

console.log(Masonry);

var QuoteCards = function(options){

  this.options = {
    $el: false
  };

  $.extend(true, this.options, options);

};

QuoteCards.prototype.init = function(){

  var $container = this.options.$el.find(".masonry-container");

  this.$masonry = new Masonry($container[0],{
    itemSelector: '[data-quote-card]',
    gutter: 40
  });

};

export default  QuoteCards;
